import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

import './index.css'



import { ChatProvider } from './features/chat';
import { ToastProvider } from './shared/ui/Toast';
import SessionGuard from './core/auth/SessionGuard';
import { applyViewportFor } from './shared/utils/desktopViewport';

// Before the first paint, so a phone never flashes the narrow layout.
applyViewportFor();

// Backstop for stale chunks after a deploy: if a module preload fails, reload
// once to fetch the fresh index.html + current chunk hashes.
window.addEventListener('vite:preloadError', () => {
    const last = Number(sessionStorage.getItem('chunkReloadAt') || 0);
    if (Date.now() - last > 10000) {
        sessionStorage.setItem('chunkReloadAt', String(Date.now()));
        window.location.reload();
    }
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        {/* Toasts sit ABOVE the chat provider. They used to be inside App, below it, so
            every message the chat and call layer showed (call failed, declined, busy…)
            fell through to a console warning and nobody ever saw it. */}
        <ToastProvider>
            <ChatProvider>
                {/* One browser, one signed-in user — see SessionGuard. */}
                <SessionGuard />
                <App />
            </ChatProvider>
        </ToastProvider>
    </React.StrictMode>,
)
